import React from 'react';
import { useSubscription } from '@/context/SubscriptionContext';
import { useSupabaseInventory } from '@/context/SupabaseInventoryContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock, Crown, AlertTriangle } from 'lucide-react';

interface RestrictedFeatureGuardProps {
  children: React.ReactNode;
  feature?: string;
  fallbackMessage?: string;
  showUpgradePrompt?: boolean;
  requiresPremium?: boolean; // Force la restriction même avec moins de 5 produits
}

export const RestrictedFeatureGuard: React.FC<RestrictedFeatureGuardProps> = ({ 
  children, 
  feature = "cette fonctionnalité",
  fallbackMessage,
  showUpgradePrompt = true,
  requiresPremium = false
}) => {
  const { hasAccess, isTrialActive, isSubscribedUser, createCheckout, isLoading } = useSubscription();
  const { products } = useSupabaseInventory();

  // Si l'utilisateur a accès premium, afficher le contenu
  if (hasAccess) {
    return <>{children}</>;
  }

  // Mode démo : permettre l'accès si moins de 5 produits et pas de restriction forcée
  if (!requiresPremium && products.length < 5) {
    return <>{children}</>;
  }

  // Afficher directement le contenu sans encart de restriction
  return <>{children}</>;
};